import { handleActions } from 'redux-actions';

import { APP_ACTION_TYPES } from './constants';
import AppState from './AppState';
import { TAB_IDS } from '../../constants';

import type { Action } from '../types';
import type {
  ReceiveErrorPayload,
  ReceiveSetActiveTabPayload,
  ReceiveAppLifecyclePayload
} from './types';

const initialState = new AppState({
  activeTab: TAB_IDS.HOME,
  initialDataLoaded: false
});

const actions = {
  // eslint-disable-next-line object-curly-spacing
  [APP_ACTION_TYPES.RECEIVE_ERROR]: (state: AppState, { payload }: Action<ReceiveErrorPayload>): AppState => {
    if (!payload) {
      return state;
    }
    return state.setError(payload.error);
  },

  // eslint-disable-next-line object-curly-spacing
  [APP_ACTION_TYPES.RECEIVE_ACTIVE_TAB]: (state: AppState, { payload }: Action<ReceiveSetActiveTabPayload>): AppState => {
    if (!payload) {
      return state;
    }
    return state.setActiveTab(payload.tab);
  },

  [APP_ACTION_TYPES.FETCH_INITIAL_DATA]: (state: AppState) => {
    return state.setInitialDataLoaded(false);
  },
  [APP_ACTION_TYPES.RECEIVE_INITIAL_DATA]: (state: AppState) => {
    return state.setInitialDataLoaded(true);
  },
  [APP_ACTION_TYPES.RECEIVE_APP_LIFECYCLE_STATE]: receiveAppLifecycleState
};

// eslint-disable-next-line object-curly-spacing
function receiveAppLifecycleState(state: AppState, { payload }: Action<ReceiveAppLifecyclePayload>): AppState {
  if (!payload) {
    return state;
  }
  return state.setAppLifecycleState(payload.appState);
}

export default handleActions(actions, initialState);



// WEBPACK FOOTER //
// ./src/redux/app/reducer.js